import { useEffect, useState } from 'react';
import { api } from '../../api.ts';

interface AuditLog {
  id: string;
  action: string;
  target_type: string | null;
  target_id: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
}

const ACTION_LABELS: Record<string, string> = {
  'user.suspend': 'Utilisateur suspendu',
  'user.activate': 'Utilisateur réactivé',
  'referrer.invite': 'Apporteur invité',
  'referrer.new_invitation': 'Nouveau lien d’accès apporteur',
  'referrer.update': 'Apporteur modifié',
  'invoice.pay_stripe': 'Facture payée (Stripe)',
  'invoice.pay_manual': 'Facture payée (virement manuel)',
  'invoice.reject': 'Facture rejetée',
  'referrer.billing_update': 'Facturation apporteur modifiée',
  'referrer.mandate_accept': 'Mandat de facturation accepté',
  'referrer.mandate_revoke': 'Mandat de facturation révoqué',
  'referrer.payout_request': 'Versement demandé',
  'commission.reverse': 'Commission annulée',
  'settings.update': 'Paramètres modifiés',
};

export function AdminAudit() {
  const [logs, setLogs] = useState<AuditLog[] | null>(null);

  useEffect(() => {
    api.get<{ logs: AuditLog[] }>('/admin/audit-logs').then((res) => setLogs(res.logs));
  }, []);

  if (!logs) return <div className="empty-state">Chargement…</div>;
  if (logs.length === 0) return <div className="empty-state">Aucune action enregistrée.</div>;

  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr><th>Date</th><th>Auteur</th><th>Action</th><th>Détail</th></tr>
        </thead>
        <tbody>
          {logs.map((l) => (
            <tr key={l.id}>
              <td style={{ whiteSpace: 'nowrap' }}>{new Date(l.created_at).toLocaleString('fr-FR')}</td>
              <td>{l.first_name ? `${l.first_name} ${l.last_name}` : l.email ?? '—'}</td>
              <td style={{ fontWeight: 700 }}>{ACTION_LABELS[l.action] ?? l.action}</td>
              <td style={{ fontSize: 12, color: 'var(--text-secondary)', maxWidth: 360, wordBreak: 'break-word' }}>
                {l.metadata ? JSON.stringify(l.metadata) : ''}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
